import * as React from "react";

import { 
    Confirm, 
    FortnoxCredential
} from "./Chapters";

export default (key, method) => {
    switch (key) {
        case "FORTNOX":
            return <    FortnoxCredential
            method={method} />;
        default:
            return <Confirm />;
    }
};